module.exports = __webpack_public_path__ + "static/img/copy.f5e3579.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/article_4/portrait/copy.png
// module id = mR3v
// module chunks = 1